// extracted by mini-css-extract-plugin
export var Container = "Wrapper-module--Container--2446f";
export var tabletOnly = "Wrapper-module--tablet-only--8f866";